import { useState, useEffect } from "react";
import { Warning, Check } from "@phosphor-icons/react";
import { BrandMark } from "@/components/Logo";

const FLAG = "quadhelix_age_verified";

export default function AgeGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(FLAG)) setOpen(true);
  }, []);

  if (!open) return null;

  const confirm = () => {
    localStorage.setItem(FLAG, "true");
    setOpen(false);
  };

  const decline = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-navy-deep/90 px-5 backdrop-blur-md animate-fade-in"
      data-testid="age-gate-overlay"
    >
      <div className="relative w-full max-w-md border border-cyan/25 bg-navy-surface p-8 shadow-glow-sm">
        <div className="mb-5 flex items-center gap-3 text-cyan">
          <BrandMark className="h-10 w-10" />
          <span className="font-heading text-xl font-black tracking-tight text-white">
            QuadHelix <span className="text-cyan">Labs</span>
          </span>
        </div>
        <div className="mb-4 flex items-center gap-2 border-l-2 border-cyan bg-navy-elevated px-3 py-2 font-mono text-xs uppercase tracking-widest text-cyan">
          <Warning size={16} weight="fill" /> Research use only
        </div>
        <h2 className="mb-3 font-heading text-2xl font-bold text-white">
          Age & Compliance Verification
        </h2>
        <p className="mb-6 text-sm leading-relaxed text-teal-muted">
          All products are sold strictly for <strong className="text-white">laboratory
          research purposes only</strong> and are <strong className="text-white">not for human
          or animal consumption</strong>. By entering, you confirm you are at least 21 years
          of age and a qualified researcher.
        </p>
        <div className="flex flex-col gap-3">
          <button
            data-testid="age-gate-confirm"
            onClick={confirm}
            className="flex items-center justify-center gap-2 bg-cyan py-3 font-mono text-sm font-semibold uppercase tracking-wider text-navy-deep transition-all duration-300 hover:bg-cyan-bright hover:shadow-glow"
          >
            <Check size={18} weight="bold" /> I am 21+ and accept
          </button>
          <button
            data-testid="age-gate-decline"
            onClick={decline}
            className="py-2 font-mono text-xs uppercase tracking-wider text-teal-muted transition-colors hover:text-white"
          >
            Exit
          </button>
        </div>
      </div>
    </div>
  );
}
